"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TALENT_PARTNER_LAW = void 0;
const question_groups_1 = require("../../../groups/question-groups");
const form_1 = require("../../../utils/form");
exports.TALENT_PARTNER_LAW = (0, form_1.form)({
    name: "TALENT_PARTNER_LAW",
    title: "Common-law Partner not Studying or Working in Canada intake form",
    content: [
        question_groups_1.QuestionGroup["TALENT_PERSONAL_DETAILS"],
        question_groups_1.QuestionGroup["TALENT_OTHER_CONTACT_INFORMATION"],
        question_groups_1.QuestionGroup["TALENT_CURRENT_COUNTRY_RESIDENCE"],
        question_groups_1.QuestionGroup["TALENT_PREVIOUS_COUNTRY_RESIDENCE"],
        question_groups_1.QuestionGroup["TALENT_MARITAL_STATUS"],
        question_groups_1.QuestionGroup["TALENT_LANGUAGES"],
        question_groups_1.QuestionGroup["TALENT_PASSPORT"],
        question_groups_1.QuestionGroup["TALENT_NATIONAL_IDENTITY"],
        question_groups_1.QuestionGroup["TALENT_US_PR"],
        question_groups_1.QuestionGroup["TALENT_EDUCATION"],
        question_groups_1.QuestionGroup["TALENT_EMPLOYMENT"],
        question_groups_1.QuestionGroup["TALENT_BACKGROUND_INFORMATION"],
        question_groups_1.QuestionGroup["TALENT_FAMILY_INFORMATION_PARTNER"],
    ],
});
